/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Stock_LowInputs */

const vi_notif_type_stock_low = /** @type {(inputs: Notif_Type_Stock_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho chạm sàn`)
};

/**

* @param {Notif_Type_Stock_LowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_stock_low = /** @type {((inputs?: Notif_Type_Stock_LowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Stock_LowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_stock_low(inputs)
});